/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";

const TermAndCondition = () => {
  return (
    <>
      <article
        className="page"
        style={{
          backgroundColor: "#e0e0e0",
        }}
      >
        <section className="page-content">
          <div className="container pt-5">
            <div className="row">
              <div className="wysiwyg col-md-8 mx-auto">
                <h2 className="text_48_privacy">
                  Terms and Conditions
                  <br />
                </h2>
                <p className="text_18_privacy">Last updated: April 28, 2023</p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h3 />
                <h3>Interpretation and Definitions</h3>
                <h4 />
                <h4>Interpretation</h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                  <br />
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h4>Definitions</h4>
                <p className="text_18_privacy">
                  {" "}
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <ul>
                  <li className="text_18_privacy">
                    <strong>Affiliate</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Country</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Company</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Device</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Feedback</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Service</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Terms and Conditions</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Third-party Social Media Service</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>Website</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                  <li className="text_18_privacy">
                    <strong>You</strong>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Esse natus ea modi similique consequatur cumque est
                    blanditiis perferendis voluptatem labore deserunt ipsa
                    consequuntur itaque recusandae dolore, rem quasi autem
                    voluptate!
                  </li>
                </ul>
                <h4 />
                <h3>
                  Acknowledgment
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>Intellectual Property</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>Your Feedback to Us</h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Links to Other Websites
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Termination
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Limitation of Liability
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  "AS IS" and "AS AVAILABLE" Disclaimer
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Governing Law
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Disputes Resolution
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  For European Union (EU) Users
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p />
                <h3>
                  United States Legal Compliance
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Severability and Waiver
                  <br />
                </h3>
                <h4>
                  Severability
                  <br />
                </h4>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h5 />
                <h4>
                  Waiver
                  <br />
                </h4>
                <p className="text_18_privacy">
                  Except as provided herein, the failure to exercise a right or
                  to require
                  <br />
                  performance of an obligation under these Terms shall not
                  effect a party's
                  <br />
                  ability to exercise such right or require such performance at
                  any time
                  <br />
                  thereafter nor shall the waiver of a breach constitute a
                  waiver of any
                  <br />
                  subsequent breach.
                </p>
                <h4 />
                <h3>
                  Translation Interpretation
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <h4 />
                <h3>
                  Changes to These Terms and Conditions
                  <br />
                </h3>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p className="text_18_privacy">
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse
                  natus ea modi similique consequatur cumque est blanditiis
                  perferendis voluptatem labore deserunt ipsa consequuntur
                  itaque recusandae dolore, rem quasi autem voluptate!
                </p>
                <p />
                <h3>
                  Contact Us
                  <br />
                </h3>
                <p className="text_18_privacy">
                  If you have any questions about these Terms and Conditions,
                  You can contact us:
                </p>
                <ul>
                  <li className="text_18_privacy">
                    By email:
                    <strong>contact@immsy.com</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </article>
    </>
  );
};

export default TermAndCondition;
